<p-dialog
  header="CareAI"
  [modal]="true"
  [(visible)]="visible"
  closeOnEscape
  dismissableMask
  draggable="false"
  (onHide)="close()"
  styleClass="care-ai-dialog">
  <div class="flex care-ai-dialog__container">
    <div class="col-3 p-0 care-ai-dialog__chat-overview">
      <div class="col-12 mt-2 mb-2 flex justify-content-center">
        <p-button
          label="New AI chat"
          size="small"
          severity="success"
          (onClick)="newPrompt()"
          icon="pi pi-send" />
      </div>
      @for (chat of chats; track $index) {
        <a
          tabindex="0"
          class="col-12 flex flex-wrap p-0 justify-content-between align-items-center care-ai-dialog__chat-overview-item"
          [class]="{
            'care-ai-dialog__chat-overview-item--active': activeChat && activeChat.id === chat.id,
          }"
          (click)="openChat(chat)">
          <p class="col-8 ml-4">
            {{ getChatTitle(chat) }}
          </p>
          <div class="col-2 flex justify-content-end">
            <i class="pi pi-trash mr-2 cursor-pointer" (click)="deleteChat(chat)" tabindex="0"></i>
          </div>
        </a>
      }
    </div>
    @if (activeChat) {
      @if (!isEditingPreferences) {
        <div class="col-9 p-0 care-ai-dialog__chat-container">
          <div class="col-12 care-ai-dialog__chat-messages">
            @for (message of activeChat.promptHistory; track message) {
              @if (message.userPrompt !== '') {
                <div class="care-ai-dialog__chat-message care-ai-dialog__chat-message--outgoing">
                  <p>{{ message.userPrompt }}</p>
                </div>
              }
              @if (message.botResponse) {
                <div class="flex">
                  <i class="pi pi-android align-self-center"></i>
                  <div class="care-ai-dialog__chat-message">
                    <p class="care-ai-dialog__message-text">{{ message.botResponse }}</p>
                  </div>
                </div>
              }
            }
          </div>
          <div
            class="col-12 flex care-ai-dialog__new-prompt justify-content-between align-items-center">
            <p-button
              icon="pi pi-cog"
              iconpos="right"
              [rounded]="true"
              [text]="true"
              (click)="editChatPreferences()" />

            <input
              pInputText
              placeholder="Type a question..."
              [(ngModel)]="prompt"
              (keyup.enter)="sendPrompt()" />
            <p-button label="Send" severity="primary" (onClick)="sendPrompt()" icon="pi pi-send" />
          </div>
        </div>
      } @else {
        <div class="col-9 p-0">
          <carehub-care-ai-preferences
            [preferences]="activeChat.preferences"
            [sources]="sources"
            (cancelPreferences)="cancelPreferences()"
            (savePreferences)="savePreferences($event)" />
        </div>
      }
    }
  </div>
</p-dialog>

<p-confirmDialog />
